import React, { useState, useEffect } from "react";
import BaseController from "controllers/BaseController";
import { ResetPasswordView } from "views/auth/ResetPassword";

import Authentication from "api/Authentication";
import UserModel from "models/User";

import { MESSAGE_SUCCES, MESSAGE_ERROR } from "../../actions/types";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

class ResetPassword extends BaseController {
  constructor(props) {
    super(props);
    this.state = { error: null, isLoaded: false, validation: false };
    this.dispatch = this.props.dispatch;
  }

  componentDidMount() {
    //		const { dispatch, history } = this.props;
    //dispatch({ type: LOGIN_SUCCESS, payload: {} });
  }
  onSaveHandler = async (data) => {
    let isLoggedIn = await Authentication.resetPassword(data);
    if (isLoggedIn.status != 200) {
      this.dispatch({
        type: MESSAGE_ERROR,
        message: "Ongeldig e-mailadres.",
        header: "Aanvragen nieuw wachtwoord mislukt",
      });
    } else if (isLoggedIn.status == 200) {
      this.dispatch({
        type: MESSAGE_SUCCES,
        message:
          "U ontvangt een e-mail met instructies om uw wachtwoord te veranderen.",
        header: "Nieuw wachtwoord succesvol aangevraagt",
      });
      this.props.navigate("/login");
      /*			
			const { history } = this.props;
			const {user, token} = isLoggedIn.data.data;
			let userModel = new UserModel(user);
			console.log( "new user model",  window.location.hostname );
			this.dispatch({ type: LOGIN_SUCCESS, payload: { user : user, token: token } });
			window.location.reload();
*/
    }
  };

  render() {
    return <ResetPasswordView onSave={this.onSaveHandler} />;
  }
}

const ResetPasswordInit = (props) => {
  let navigate = useNavigate();
  //return (React.createElement(ComponentName, {...props, navigate:navigate, isLoggedIn: false}))
  //return (<Compo {...props} navigate={navigate}/>)
  return <ResetPassword {...props} navigate={navigate} />;
};

function mapStateToProps(state) {
  const { isLoggedIn } = state.auth;
  return {
    isLoggedIn,
  };
}

export default connect(mapStateToProps)(ResetPasswordInit);
